import React, { ReactElement } from 'react';
import { HStack, VStack, Text } from '@chakra-ui/react';
import { useCategories } from 'hooks/api/backend/folder/getAllParentFolders';
import { ListIcon } from 'assets/icons/v2';
import { Category } from '@novaheal/types';
import { CategoryCard } from 'components/Search/Categories/CategoryCard';

export const Categories = (): ReactElement => {
  const { data: categoriesData } = useCategories();

  return (
    <VStack
      bg="background.primary"
      align="left"
      gap={{ base: '32px', md: '40px' }}
      width="100%"
      borderRadius={{ md: '2xl' }}
      p={{ base: '10px 28px', md: '20px' }}
    >
      <HStack>
        <ListIcon h="22px" w="22px" color="icon.primary" />
        <Text textStyle="h4.regular" color="text.primary">
          Kategorien
        </Text>
      </HStack>
      {categoriesData &&
        categoriesData.map((category: Category) => (
          <CategoryCard
            id={category.id}
            title={category.title}
            numberOfArticles={category.totalArticles}
            numberOfFolders={category.totalSubfolders}
            image={category.image}
            key={category.id}
          />
        ))}
    </VStack>
  );
};
